import { Layout } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BlueButton } from "@react-solutions-ui/findmore-ui";
import errorIllustration from "../../assets/icons/error_illustration.svg";
import Footer from "../../components/layout/Footer/Footer";
import NavBar, { NavItem } from "../../components/layout/NavBar/NavBar";
import styles from "./Error.module.css";

const { Content } = Layout;

const errorNavItems: NavItem[] = [
  { key: "home", label: "Início", path: "/home" },
];

export default function Error() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const message = searchParams.get("message");
  const errorCode = searchParams.get("errorCode");

  const handleGoHome = () => {
    navigate("/home");
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#F9F9F9" }}>
      <NavBar items={errorNavItems} />
      <Content style={{ background: "#F9F9F9" }}>
        <div className={styles.page}>
          <main className={styles.main}>
            <div className={styles.textBlock}>
              <h1 className={styles.title}>Uuuups!</h1>
              <p className={styles.description}>
                {message ||
                  "Esta página recebeu tanto feedback que entrou em burnout."}
              </p>
              <h3 className={styles.errorCode}>ERRO {errorCode || "404"}</h3>

              {/* Illustration for mobile only */}
              <img
                src={errorIllustration}
                alt="Ilustração de colaboradores a rever feedback"
                className={styles.mobileIllustration}
              />

              <BlueButton
                text="Voltar à página inicial"
                onClick={handleGoHome}
                className={styles.primaryButton}
              />
            </div>

            <img
              src={errorIllustration}
              alt="Ilustração de colaboradores a rever feedback"
              className={styles.illustration}
            />
          </main>
        </div>
      </Content>
      <Footer />
    </Layout>
  );
}
